import { useOfflineStore } from './state';

/** Only a tenant using offline tills gets a service worker, and only in a real build. */
export async function registerTillWorker(): Promise<void> {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  try {
    await navigator.serviceWorker.register('/sw.js');
  } catch {
    // The till still works online; offline reload just won't.
  }
}

/** The tenant turned offline tills off: stop intercepting anything. */
export async function unregisterTillWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((r) => r.unregister()));
}

/** Hold the browser's install prompt until the cashier taps Install. */
export function captureInstallPrompt(): void {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    useOfflineStore
      .getState()
      .set({ installPrompt: event as unknown as { prompt: () => Promise<unknown> } });
  });
  window.addEventListener('appinstalled', () => {
    useOfflineStore.getState().set({ installPrompt: null });
  });
}
